// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BdH3","title":"styles_title__3sFVn"};